
import React, { Component } from 'react';
import { Trans } from 'react-i18next';
import Step1 from "../../assets/images/image-guide/1.jpeg";
import Step2 from "../../assets/images/image-guide/2.jpeg";
import Step3 from "../../assets/images/image-guide/3.jpeg";
import Step4 from "../../assets/images/image-guide/4.jpeg";
import Step5 from "../../assets/images/image-guide/5.jpeg";
import truemoney_logo from "../../assets/images/image-guide/truemoney_logo_2x.webp";
import { t } from 'i18next';
import { Image, Typography } from 'antd';

const { Text, } = Typography;
export class TrueWalletGuide extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // คุณสามารถเพิ่ม state ที่ต้องการได้ที่นี่
        };
    }
    render() {
        const { webHookUrl_wallet, } = this.props; // ใช้ context ที่ส่งมาจาก AppContext
        // --- สไตล์ CSS ในรูปแบบวัตถุ (Styles Object) ---
        const styles = {
            hero: {
                backgroundColor: 'transparent',
                padding: '20px',
                textAlign: 'center',
                fontFamily: 'sans-serif'
            },
            heroLogo: {
                fontSize: '48px',
                marginBottom: '10px'
            },
            heroBadge: {
                display: 'inline-block',
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                padding: '4px 12px',
                borderRadius: '12px',
                fontSize: '14px',
                marginBottom: '15px'
            },
            heroH1: {
                fontSize: '28px',
                margin: '0 0 10px 0'
            },
            heroP: {
                fontSize: '16px',
                margin: 0,
                lineHeight: '1.5'
            },
            container: {
                maxWidth: '800px',
                margin: '0 auto',
                padding: '20px',
                fontFamily: 'sans-serif',
                color: '#333333'
            },
            requirement: {
                backgroundColor: '#fff3cd',
                borderLeft: '5px solid #ffc107',
                padding: '15px',
                borderRadius: '4px',
                marginBottom: '30px'
            },
            requirementHeader: {
                fontWeight: 'bold',
                color: '#856404',
                marginBottom: '10px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
            },
            sec: {
                display: 'flex',
                alignItems: 'center',
                margin: '0px 0',
                color: '#ff5722',
                fontFamily: 'sans-serif'
            },
            secHr: {
                flex: 1,
                border: 'none',
                borderTop: '1px solid #e0e0e0',
                margin: 0
            },
            secLabel: {
                padding: '0 15px',
                fontWeight: 'bold',
                fontSize: '18px'
            },
            secLabel2: {
                padding: '0 15px',
                fontWeight: 'bold',
                fontSize: '18px',
                color: '#28a745'
            },
            linkCard: {
                backgroundColor: '#ffffff',
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                padding: '24px',
                textAlign: 'center',
                marginBottom: '24px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                fontFamily: 'sans-serif'
            },
            linkIcon: {
                fontSize: '40px',
                marginBottom: '10px'
            },
            linkCardH3: {
                margin: '0 0 10px 0',
                fontSize: '18px',
                fontWeight: 'bold'
            },
            linkCardP: {
                margin: '0 0 20px 0',
                color: '#666',
                lineHeight: '1.6',
                fontSize: '14px'
            },
            btnPrimary: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                backgroundColor: '#ff5722',
                color: '#ffffff',
                textDecoration: 'none',
                padding: '12px 24px',
                borderRadius: '6px',
                fontWeight: 'bold',
                fontSize: '15px',
                border: 'none',
                cursor: 'pointer',
                transition: 'background-color 0.2s'
            },
            btnSvg: {
                width: '18px',
                height: '18px',
                stroke: 'currentColor',
                strokeWidth: 2,
                fill: 'none',
                strokeLinecap: 'round',
                strokeLinejoin: 'round'
            },
            note: {
                backgroundColor: '#f8f9fa',
                borderLeft: '4px solid #6c757d',
                padding: '15px',
                borderRadius: '4px',
                display: 'flex',
                gap: '12px',
                alignItems: 'flex-start'
            },
            noteInfo: {
                backgroundColor: '#e8f4fd',
                borderLeftColor: '#17a2b8'
            },
            noteSuccess: {
                backgroundColor: '#d4edda',
                borderLeftColor: '#28a745'
            },
            noteIcon: {
                fontSize: '18px'
            },
            noteP: {
                margin: 0,
                fontSize: '14px',
                lineHeight: '1.5'
            },
            stepCard: {
                backgroundColor: '#ffffff',
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                marginBottom: '24px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                overflow: 'hidden'
            },
            stepCard2: {
                backgroundColor: '#ffffff',
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                marginBottom: '24px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                overflow: 'hidden',
                borderLeft: '4px solid #28a745'
            },
            stepHeader: {
                backgroundColor: '#f8f9fa',
                padding: '15px 20px',
                borderBottom: '1px solid #e0e0e0',
                display: 'flex',
                alignItems: 'center',
                gap: '12px'
            },
            stepnumber: {
                backgroundColor: '#ff5722',
                color: '#ffffff',
                width: '28px',
                height: '28px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 'bold',
                fontSize: '14px'
            },
            stepTitle: {
                fontWeight: 'bold',
                fontSize: '16px',
                flex: 1
            },
            stepTag: {
                backgroundColor: '#e9ecef',
                color: '#495057',
                padding: '2px 8px',
                borderRadius: '4px',
                fontSize: '12px'
            },
            stepBody: {
                padding: '20px'
            },
            stepBodyP: {
                margin: '0 0 15px 0',
                lineHeight: '1.6',
                fontSize: '15px'
            },
            action: {
                backgroundColor: '#fff0eb',
                color: '#ff5722',
                padding: '2px 6px',
                borderRadius: '4px',
                fontWeight: 'bold'
            },
            act: {
                backgroundColor: '#eafaf1',
                color: '#28a745',
                padding: '2px 6px',
                borderRadius: '4px',
                fontWeight: 'bold'
            },
            imgWrap: {
                backgroundColor: '#f8f9fa',
                border: '1px solid #e9ecef',
                borderRadius: '6px',
                padding: '15px',
                textAlign: 'center',
                marginBottom: '10px'
            },
            img: {
                maxWidth: '100%',
                height: 'auto',
                borderRadius: '4px'
            },
            imgCaption: {
                textAlign: 'center',
                fontSize: '13px',
                color: '#6c757d',
                margin: '0 0 15px 0',
                lineHeight: '1.4'
            },
            urlBox: {
                backgroundColor: '#212529',
                color: '#f8f9fa',
                padding: '12px',
                borderRadius: '6px',
                fontSize: '14px',
                overflowX: 'auto',
                marginBottom: '15px',
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
            },
            urlLabel: {
                color: '#ffc107',
                fontSize: '11px',
                fontWeight: 'bold',
                textTransform: 'uppercase'
            },
            code: {
                color: '#fff',
                wordBreak: 'break-all',
                cursor: 'copy'
            },
            footer: {
                backgroundColor: '#343a40',
                color: '#ffffff',
                textAlign: 'center',
                padding: '30px 20px',
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "6px",
                boxSizing: 'border-box'
            },
            footerP: {
                margin: 0
            }
        };

        let url_webhook = `${webHookUrl_wallet}`;

        return (
            <div>
                <div style={styles.hero}>
                    <div style={styles.heroLogo}><Image preview={false} src={truemoney_logo}></Image></div>
                    <div style={styles.heroBadge}>{t('hero.badge')}</div>
                    <h1 style={styles.heroH1}>{t('hero.title')}</h1>
                    <p style={styles.heroP}>{t('hero.desc')}</p>
                </div>

                <div style={styles.container}>
                    <div style={styles.requirement}>
                        <div style={styles.requirementHeader}>
                            <span>⚠️</span> {t('requirement.header')}
                        </div>
                        <p style={{ margin: 0, lineHeight: '1.6' }}>
                            {t('requirement.desc_1')} <strong>Webhook API</strong> {t('requirement.desc_2')} <strong>{t('requirement.min_tx')}</strong> {t('requirement.desc_3')} <strong>{t('requirement.min_amount')}</strong> {t('requirement.desc_4')}
                        </p>
                    </div>
                </div>

                {/* Section 1 Line */}
                <div style={styles.sec}>
                    <hr style={styles.secHr} /><span style={styles.secLabel}>{t('sections.part1')}</span><hr style={styles.secHr} />
                </div>

                <div style={styles.container}>
                    {/* Link Card Direct Jump */}
                    <div style={styles.linkCard}>
                        <div style={styles.linkIcon}>📱</div>
                        <h3 style={styles.linkCardH3}>{t('link_card.title')}</h3>
                        <p style={styles.linkCardP}>
                            {t('link_card.desc_1')} <strong>{t('link_card.target_page')}</strong> {t('link_card.desc_2')}
                        </p>
                        <a href="https://www.truemoney.com/truemoney-open-api/?goto=tab-check-acc-content" target="_blank" rel="noopener noreferrer" style={styles.btnPrimary}>
                            <svg style={styles.btnSvg} viewBox="0 0 24 24">
                                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                                <polyline points="15 3 21 3 21 9" />
                                <line x1="10" y1="14" x2="21" y2="3" />
                            </svg>
                            {t('link_card.btn_text')}
                        </a>
                    </div>

                    {/* Step 1 */}
                    <div style={styles.stepCard}>
                        <div style={styles.stepHeader}>
                            <div style={styles.stepnumber}>1</div>
                            <div style={styles.stepTitle}>{t('steps.s1.title')}</div>
                            <span style={styles.stepTag}>{t('steps.s1.tag')}</span>
                        </div>
                        <div style={styles.stepBody}>
                            <p style={styles.stepBodyP}>
                                {t('steps.s1.body_1')} <span style={styles.action}>{t('steps.webhook_notif')}</span> {t('steps.s1.body_2')}
                            </p>
                            <div style={styles.imgWrap}>
                                <Image preview={false} src={Step1} alt="" width="288" height="640" style={styles.img} />
                            </div>
                            <p style={styles.imgCaption}>{t('steps.s1.img_caption')}</p>
                        </div>
                    </div>

                    {/* Step 2 */}
                    <div style={styles.stepCard}>
                        <div style={styles.stepHeader}>
                            <div style={styles.stepnumber}>2</div>
                            <div style={styles.stepTitle}>{t('steps.s2.title')}</div>
                            <span style={styles.stepTag}>{t('steps.s2.tag')}</span>
                        </div>
                        <div style={styles.stepBody}>
                            <p style={styles.stepBodyP}>
                                <strong>{t('steps.s2.sub_1')}</strong> {t('steps.s2.body_1')} <span style={styles.action}>{t('steps.s2.action_accept')}</span> {t('steps.s2.body_2')}
                            </p>
                            <p style={styles.stepBodyP}>
                                <strong>{t('steps.s2.sub_2')}</strong> {t('steps.s2.body_3')}
                            </p>
                            <div style={styles.urlBox}>
                                <span style={styles.urlLabel}>URL</span>
                                <Text className='code' code copyable style={styles.code}>{url_webhook}</Text>
                                {/* <span title='Copy to clipboard' className='hover fs-12' onClick={() => CopyTextToClipboard(url_webhook)} style={styles.code}>{url_webhook}</span> */}
                            </div>
                            <p style={styles.stepBodyP}>
                                <strong>{t('steps.s2.sub_3')}</strong> {t('steps.s2.body_4')} <span style={styles.action}>{t('steps.s2.action_submit')}</span> {t('steps.s2.body_5')}
                            </p>
                            <div style={styles.imgWrap}>
                                <Image preview={false} src={Step2} alt="" width="288" height="640" style={styles.img} />
                            </div>
                            <p style={styles.imgCaption}>{t('steps.s2.img_caption')}</p>
                        </div>
                    </div>

                    {/* Step 3 */}
                    <div style={styles.stepCard}>
                        <div style={styles.stepHeader}>
                            <div style={styles.stepnumber}>3</div>
                            <div style={styles.stepTitle}>{t('steps.s3.title')}</div>
                            <span style={styles.stepTag}>{t('steps.s3.tag')}</span>
                        </div>
                        <div style={styles.stepBody}>
                            <p style={styles.stepBodyP}>
                                {t('steps.s3.body_1')} <strong>Secret Key</strong> {t('steps.s3.body_2')} <span style={styles.action}>{t('steps.s3.copy')}</span> {t('steps.s3.body_3')}
                            </p>

                            <div style={{ ...styles.note, ...styles.noteSuccess }}>
                                <span style={styles.noteIcon}>✅</span>
                                <p style={styles.noteP}>{t('steps.s3.note_success')}</p>
                            </div>

                            <div style={{ ...styles.note, marginTop: '12px' }}>
                                <span style={styles.noteIcon}>⚠️</span>
                                <p style={styles.noteP}>
                                    <strong>{t('steps.s3.note_warn_title')}</strong> {t('steps.s3.note_warn_1')} <em>{t('steps.s3.note_warn_page')}</em> {t('steps.s3.note_warn_2')} <strong>{t('steps.s3.note_warn_btn')}</strong> {t('steps.s3.note_warn_3')} <strong>{t('steps.s3.note_warn_4')}</strong> {t('steps.s3.note_warn_5')}
                                </p>
                            </div>

                            <div style={{ ...styles.imgWrap, marginTop: '15px' }}>
                                <Image preview={false} src={Step3} alt="" width="288" height="640" style={styles.img} />
                            </div>
                            <p style={styles.imgCaption}>{t('steps.s3.img_caption')}</p>
                        </div>
                    </div>

                    <div style={{ ...styles.note, ...styles.noteInfo, margin: '40px 0 60px' }}>
                        <span style={styles.noteIcon}>💡</span>
                        <p style={styles.noteP}>
                            <strong>{t('steps.summary_title')}</strong> {t('steps.summary_desc')}
                        </p>
                    </div>
                </div>

                {/* Section 2 Line */}
                <div style={styles.sec}>
                    <hr style={styles.secHr} /><span style={styles.secLabel2}>{t('sections.part2')}</span><hr style={styles.secHr} />
                </div>

                <div style={styles.container}>
                    {/* Step 4 */}
                    <div style={styles.stepCard2}>
                        <div style={styles.stepHeader}>
                            <div style={styles.stepnumber}>4</div>
                            <div style={styles.stepTitle}>{t('steps.s4.title')}</div>
                            <span style={styles.stepTag}>{t('steps.s4.tag')}</span>
                        </div>
                        <div style={styles.stepBody}>
                            <p style={styles.stepBodyP}>
                                {t('steps.s4.body_1')} <span style={styles.act}>{t('steps.check_balance')}</span> {t('steps.s4.body_2')}
                            </p>
                            <div style={styles.imgWrap}>
                                <Image preview={false} src={Step4} alt="" width="288" height="640" style={styles.img} />
                            </div>
                            <p style={styles.imgCaption}>{t('steps.s4.img_caption')}</p>
                        </div>
                    </div>

                    {/* Step 5 */}
                    <div style={styles.stepCard2}>
                        <div style={styles.stepHeader}>
                            <div style={styles.stepnumber}>5</div>
                            <div style={styles.stepTitle}>{t('steps.s5.title')}</div>
                            <span style={styles.stepTag}>{t('steps.s5.tag')}</span>
                        </div>
                        <div style={styles.stepBody}>
                            <p style={styles.stepBodyP}>
                                {t('steps.s5.body_1')} <span style={styles.act}>{t('steps.s5.copy_token')}</span> {t('steps.s5.body_2')} <strong>Authorization → Payeasy</strong> {t('steps.s5.body_3')}
                            </p>
                            <div style={styles.imgWrap}>
                                <Image preview={false} onClick={() => window.open(Step5)} src={Step5} alt="" width="576" height="1280" style={styles.img} />
                            </div>
                            <p style={styles.imgCaption}>{t('steps.s5.img_caption')}</p>
                            <p className="text-danger fs-12" style={{ marginLeft: 8, marginTop: 3, marginBottom: 0 }}>
                                <Trans
                                    i18nKey="tooltip_truewallet_fee"
                                    components={[<small />, <a href="https://www.truemoney.com/fee/" style={{ textDecoration: "underline" }} target="_blank" rel="noreferrer" />]}
                                />
                            </p>
                        </div>
                    </div>
                </div>

                <footer style={styles.footer}>
                    <p style={styles.footerP}><strong>{t('footer.title')}</strong></p>
                    <p style={{ ...styles.footerP, marginTop: '6px' }}>{t('footer.desc')}</p>
                </footer>
            </div>
        );
    }
}